import React from 'react';
import TopBanner from './TopBanner';
import Map from './Map';
import FeaturesList from './FeaturesList';
import Promotion from './Promotion';
import Categories from './Categories';
import DeliveryBlock from './DeliveryBlock';
import Slider from './Slider';
import './style/Main.css';

function Main() {
  return (
    <main className="main-content">
      <TopBanner />
      <FeaturesList />
      <Promotion />
      <div className="product-list-content-main">
        <Slider />
      </div>
      <Categories />
      <DeliveryBlock />
      <Map />
    </main>
  );
}

export default Main;
